var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 135,
    viewBox: "0 0 143 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 9.20087C38.7273 9.20087 11.1664 27.6535 0 53.7009C11.1664 79.7482 38.7273 98.2009 71 98.2009C103.273 98.2009 130.834 79.7482 142 53.7009C130.834 27.6535 103.273 9.20087 71 9.20087ZM71 83.3675C53.1855 83.3675 38.7273 70.0769 38.7273 53.7009C38.7273 37.3249 53.1855 24.0342 71 24.0342C88.8145 24.0342 103.273 37.3249 103.273 53.7009C103.273 70.0769 88.8145 83.3675 71 83.3675Z",
    fill: "#A3BBDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1287 9.33999C72.9718 9.3338 72.8169 9.32769 72.6641 9.32158C64.9645 9.21463 58.4607 10.0148 53.0405 11.1975C40.8429 13.8589 31.2601 23.5975 28.5664 35.788C27.2973 41.5309 26.625 47.5277 26.625 53.6965C26.625 85.9693 45.0258 113.53 71 124.697C96.9742 113.53 115.375 85.9693 115.375 53.6965C115.375 47.5347 114.704 41.5446 113.438 35.8076C110.745 23.6044 101.101 13.9781 88.9138 11.2119C82.2532 9.7001 77.0544 9.49493 73.1287 9.33999ZM70.9496 24.2981C54.2567 24.2981 38.8281 35.8067 38.8281 53.6965C38.8281 71.5864 54.2567 83.3723 70.9496 83.3723C87.6424 83.3723 103.071 71.5864 103.071 53.6965C103.071 35.8067 87.6424 24.2981 70.9496 24.2981Z",
    fill: "#1956A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5859 53.6965C51.5859 43.8749 60.235 35.9465 70.9496 35.9465C81.6641 35.9465 90.3132 43.8749 90.3132 53.6965C90.3132 63.5182 81.6641 71.4465 70.9496 71.4465C60.235 71.4465 51.5859 63.5182 51.5859 53.6965Z",
    fill: "#FFA05C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.873 89.6361C45.6242 94.9714 57.9254 98 71.0001 98C84.0747 98 96.376 94.9714 107.127 89.6361C99.3236 105.511 86.5125 118.028 71.0001 124.697C55.4877 118.028 42.6766 105.511 34.873 89.6361Z",
    fill: "#144586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdTracker);
export default __webpack_public_path__ + "static/media/ID Tracker.b70d6658abb85d8c747167e6f0624f62.svg";
export { ForwardRef as ReactComponent };